const mapUserReactionsToDomain = (articleId, response) => {
  if (!response.reactions[articleId]) {
    return '';
  }

  return response.reactions[articleId].type;
};

const mapAllReactionsToDomain = (articleId, response) => {
  if (!response.reactions[articleId]) {
    return [];
  }

  return response.reactions[articleId];
};

export {mapAllReactionsToDomain, mapUserReactionsToDomain};
